import ScrollToTop from "react-scroll-to-top";
import { FaArrowUp } from "react-icons/fa6";
import "./style.scss";


const ScrollToTopUI = () => {
    return (
        <div className="back-top">
            <ScrollToTop
                smooth
                viewBox="0 0 384 512"
                component={<FaArrowUp />}
            />
        </div>
    );
};

export default ScrollToTopUI;
